<template lang="pug">
div.upper-subpanel--inside
  div.col-6
    DrugInfo
  div.col-6
    ConfirmFlow(
      v-if="currentProgress ==='confirm'"
      :confirmProgress="confirmProgress"
      v-on:confirmationFinish="getConfirmData"
    )
    Loader(
      v-if="currentProgress === 'finish'"
    )
</template>

<script>
import ConfirmFlow from './ConfirmFlow';
import DrugInfo from '../flowComp/DrugInfo';
import Loader from '../common/Loader';
import MultiFlowBase from '../ComponentBase/MultiFlowBase';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  components: {
    ConfirmFlow,
    DrugInfo,
  },
  props: [],
  data() {
    return {
    };
  },
  methods: {
    getConfirmData() {
      console.log('get confirm data');
      this.stage = 'finish';
      if (this.nextEvent === null || this.nextDrugInDevice === null) {
        this.$emit('setAllConfirmData');
        this.resetProgress();
      } else {
        this.$store.dispatch('toNextEvent');
        console.log('next event');
        this.eventSwitch();
      }
    },
  },
  created() {
    this.$store.dispatch('fromFirstEvent');
  },
  computed: {
    selectedEventId() {
      return this.$store.state.event.selectedEventId;
    },
  },
};
</script>




// WEBPACK FOOTER //
// MultiFlow.vue?17d75079